import React, { useState } from "react";
import { ChangingLanguage } from "../../shared/components/ChangingLanguage";
import { useTranslation } from "react-i18next";
import { normalizedLocale } from "../../common/libs/normalizedLocale";
import { Formik, Field, Form } from 'formik';
import { FaExclamationCircle } from "react-icons/fa";
import style from "./autorization.module.css";
import * as Yup from "yup";
import Cookies from "js-cookie"; // Для работы с куками
import { authenticate } from "../../common/api/authApi";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../shared/hook";
import ModalComponent from "../../shared/Ui/ModalComponent/ModalWindow";
import ModalButton from "../../shared/Ui/Buttons/ModalButtons";


const Authorization = () => {
  const { t, i18n } = useTranslation();
  const locale = normalizedLocale(i18n.language);
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [errorModal,setErrorModal]=useState<any>(null);


  const validationSchema = Yup.object().shape({
    username: Yup.string().required('Введите логин'),
    password: Yup.string().required('Введите пароль'),
  });

  const handleSubmit = async (values: any, formik: any) => {
    const experies = Math.floor(Date.now() / 1000) + '3200';

    try {
      // Вызов функции аутентификации с переданными значениями логина и пароля
      const authResponse = await authenticate(values.username, values.password);

      // Сохранение токенов в куки
      Cookies.set('access_token', authResponse.access_token, { secure: true, sameSite: 'Strict' });
      Cookies.set('refresh_token', authResponse.refresh_token, { secure: true, sameSite: 'Strict' });
      Cookies.set('token_type', authResponse.token_type, { secure: true, sameSite: 'Strict' });
      Cookies.set("token_expiry", experies);
      // Дополнительная логика после успешной авторизации
      // dispatch(login());

      navigate("/main");
    } catch (error:any) {
      formik.setErrors({ username: "Неправильный логин или пароль" });
      const errorMessage =
            error.response?.data?.message || "Произошла ошибка";
          setErrorModal({ errorMessage });
    }
  };



  return (
    <>
      <Formik
      initialValues={{ username: '', password: '' }}
      onSubmit={handleSubmit}
      enableReinitialize={true}
      validateOnBlur={true}
      validateOnChange={true}
      validationSchema={validationSchema}
    >
      {(formik) => (
        <Form>
          <div className="bg-bg flex items-center justify-center h-screen">
            <div className="flex flex-col justify-between bg-white p-8 rounded-lg shadow-lg w-96 mx-10">
              <a href="/" className="flex justify-center mb-4 font-bold text-mainColor text-3xl">
                <img
                  src={`/icons/arm-logo.svg`}
                  alt="E-Track Logo"
                  className={` h-12 origin-left font-medium text-xl duration-200 ${!open && "scale-0"
                    }`}
                />
              </a>

              {/* Поле логина */}
              <div className={style.inputField}>
                <div className={style.labelAndButtonWrapper}>
                  <label className={style.inputLabel2}>
                    Логин*
                  </label>
                  {formik.touched.username &&
                    formik.errors.username && (
                      <div className={style.tooltipWrapper}>
                        <FaExclamationCircle className={style.errorIcon} />
                        <div className={style.tooltipText}>
                          {typeof formik.errors.username === "string"
                            ? formik.errors.username
                            : "Ошибка"}
                        </div>
                      </div>
                    )}
                </div>
                <Field
                  name="username"
                  placeholder={"Введите логин"}
                  className="input"
                />
              </div>

              {/* Поле пароля */}
              <div className={style.inputField}>
                <div className={style.labelAndButtonWrapper}>
                  <label className={style.inputLabel2}>
                    Пароль*
                  </label>
                  {formik.touched.password && formik.errors.password && (
                    <div className={style.tooltipWrapper}>
                      <FaExclamationCircle className={style.errorIcon} />
                      <div className={style.tooltipText}>
                        {typeof formik.errors.password === "string"
                          ? formik.errors.password
                          : "Ошибка"}
                      </div>
                    </div>
                  )}
                </div>
                <div className="relative flex items-center">
                  <Field
                    type={showPassword ? "text" : "password"}  // Меняем тип на 'text', если показываем пароль
                    name="password"
                    placeholder="Введите пароль"
                    className="placeholder" // Ваш класс для стилей
                  />

                  <button
                    type="button"
                    onClick={() => setShowPassword((prev:any) => !prev)}
                    className="absolute right-2" // Позиционирование кнопки
                  >
                    {!showPassword ? (
                      <img
                        src="/icons/visible_eye.svg"
                        alt="Скрыть пароль" // Добавлено свойство alt для доступности
                        className="block h-[20px] w-[20px] duration-200 group-hover:brightness-200 group-hover:invert-1"
                      />
                    ) : (
                      <img
                        src="/icons/dis_eye.svg"
                        alt="Показать пароль"
                        className="block h-[20px] w-[20px] duration-200 group-hover:brightness-200 group-hover:invert-1"
                      />

                    )}
                  </button>
                </div>
              </div>

              {/* Кнопка отправки */}
              <div className="w-full flex items-center justify-between mt-4">
                <button
                  className="bg-mainColor hover:brightness-75 text-white font-medium py-2 px-4 rounded"
                  type="submit"
                  disabled={formik.isSubmitting}
                >
                  Войти
                </button>

                <div className="relative ml-4">
                  <ChangingLanguage onlyDesktop={true} />
                  <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-600">
                    <i className="fas fa-chevron-down"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Form>
      )}
    </Formik>

<ModalComponent
        isOpen={errorModal}
        onClose={() => {
          setErrorModal(null);
        }}
        headerContent={<h1 className={style.modal__header}>Уведомление</h1>}
        content={
          <p className={style.modal__text}>
            {`${errorModal?.errorMessage ? errorModal?.errorMessage : "ошибка."}`}
          </p>
        }
        customContent={
          <ModalButton
            type="button"
            onClick={() => {
              setErrorModal(null);
            }}
          >
            {t("mainButtons.accept")}
          </ModalButton>
        }
      />
    </>
    

  );
};

export default Authorization;
